export const scrollDetector = () => {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var raw = element[0];
            element.bind('scroll', function () {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                    scope.$apply(attrs.scrollDetector);
                }
            });
        }
    };
};



// WEBPACK FOOTER //
// ./src/app/common/directives/scrollDetector.js